import { render } from "./Create.vue?vue&type=template&id=5471da8c&scoped=true&ts=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import "./Create.vue?vue&type=style&index=0&id=5471da8c&scoped=true&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5471da8c"]])

export default __exports__